import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Instructure UI imports
import { InstUISettingsProvider } from '@instructure/ui'

// const root = ReactDOM.createRoot(document.getElementById('root'))
// root.render(
//   <InstUISettingsProvider>
//     <App />
//   </InstUISettingsProvider>
// )

// Optional: customize theme here
const theme = createTheme({
    palette: {
      mode: "light", // or "dark"
    },
});
  
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <InstUISettingsProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </InstUISettingsProvider>
  </React.StrictMode>
);